<template>
  <div class="link-group is-multiline">
    <router-link :to="detailPath">
      <p class="text-primary text-bold text-paragraph text-xs space-b-1"
        v-html="step.step_abbreviation"></p>
      <p class="text-paragraph" v-html="step.step_name"></p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      required: true,
    },
  },

  computed: {
    detailPath() {
      return this.$wcRouter.path({
        name: 'step.index',
        params: { id: this.step.step_id }
      })
    }
  }
}
</script>
